import { render, staticRenderFns } from "./TaxDetailsPrompt.vue?vue&type=template&id=14b9832d&scoped=true"
import script from "./TaxDetailsPrompt.vue?vue&type=script&lang=js"
export * from "./TaxDetailsPrompt.vue?vue&type=script&lang=js"
import style0 from "./TaxDetailsPrompt.vue?vue&type=style&index=0&id=14b9832d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b9832d",
  null
  
)

export default component.exports